
import { defineComponent } from 'vue'
import ALoader from '@/components/ALoader.vue'
import ProfilePostList from '@/components/Profile/ProfilePostList.vue'

export default defineComponent({
  name: 'AllPostList',
  components: { ProfilePostList, ALoader },
})
